import React from 'react';
import ReactDOM from 'react-dom';
import Callback from './components/Callback';
import MainPage from './components/MainPage';
import DictListwy from './components/DictListwy';
import Zlecenia from './components/Zlecenie/Zlecenia';
import StanListwy from './components/StanListwy/StanListwy';
import StanPass from './components/StanPass/StanPass';
import Utarg from './components/Utarg';
import ListwyDoZam from './components/ListwyDoZam';
import { Router, Route} from 'react-router-dom';
import { requireAuth } from './utils/AuthService';
import createBrowserHistory from "./components/history";

class App extends React.Component {

  render() {

    return(
      <div className="container">
        <Router history={createBrowserHistory}>
          <div className="container">
            <Route path="/" component={MainPage}/>
            <Route path="/zlecenie" component={Zlecenia} onEnter={requireAuth} />
            <Route path="/stanListwy" component={StanListwy} onEnter={requireAuth} />
            <Route path="/stanPass" component={StanPass} onEnter={requireAuth} />
            <Route path="/dictListwy" component={DictListwy} onEnter={requireAuth} />
            <Route path="/utarg" component={Utarg} onEnter={requireAuth} />
            <Route path="/listwyDoZam" component={ListwyDoZam} onEnter={requireAuth} />
            <Route path="/callback" component={Callback} onEnter={requireAuth} />
          </div>
        </Router>
      </div>
    )
    }
  }

  ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js